"use strict";
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.setConsentResponse = exports.setTaskDetails = exports.PatientConsentSlice = void 0;
var toolkit_1 = require("@reduxjs/toolkit");
var ReduxStoreHelper_1 = require("../../youwell-common/ReduxStoreHelper");
var initialState = {
    taskDetails: {},
};
exports.PatientConsentSlice = (0, toolkit_1.createSlice)({
    name: 'PatientConsentSlice',
    initialState: initialState,
    reducers: {
        setTaskDetails: function (state, action) {
            if (action.payload.response) {
                state.taskDetails[action.payload.response.id] = action.payload.response;
            }
        },
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        setConsentResponse: function (state, action) {
            // void -> Action is handeled in AuthStore
        },
    },
    extraReducers: (_a = {},
        _a[ReduxStoreHelper_1.LOGOUT] = function () { return initialState; },
        _a),
});
exports.setTaskDetails = (_b = exports.PatientConsentSlice.actions, _b.setTaskDetails), exports.setConsentResponse = _b.setConsentResponse;
exports.default = exports.PatientConsentSlice.reducer;
